var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9061 5.5625C16.2157 2.25 12.8348 0 9.01565 0C5.16522 0 1.78435 2.25 0.093913 5.5625C0.0313043 5.6875 0 5.84375 0 6C0 6.1875 0.0313043 6.34375 0.093913 6.46875C1.78435 9.78125 5.16522 12 9.01565 12C12.8348 12 16.2157 9.78125 17.9061 6.46875C17.9687 6.34375 18 6.1875 18 6.03125C18 5.84375 17.9687 5.6875 17.9061 5.5625ZM9.01565 10.5C6.5113 10.5 4.50783 8.5 4.50783 6C4.50783 3.53125 6.5113 1.5 9.01565 1.5C11.4887 1.5 13.5235 3.53125 13.5235 6V6.03125C13.5235 8.5 11.4887 10.5312 9.01565 10.5312V10.5ZM9.01565 3C8.73391 3.03125 8.45217 3.0625 8.20174 3.125C8.38957 3.375 8.48348 3.6875 8.48348 4.03125C8.48348 4.84375 7.82609 5.5 7.01217 5.5C6.66783 5.5 6.35478 5.40625 6.10435 5.21875C6.04174 5.46875 6.01044 5.75 6.01044 6C6.01044 7.65625 7.35652 9 9.01565 9C10.6748 9 12.0209 7.65625 12.0209 6C12.0209 4.34375 10.6748 3.03125 9.01565 3.03125V3Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.6c433d75d53262fc3d83d1ddf2dd2501.svg";
export { ForwardRef as ReactComponent };